export const container = {
    pageToolbar: {
        collection_data: 'נתוני גבייה',
        contacts: 'יצירת קשר',
        maintenance: 'תחזוקה',
        soon: 'בקרוב',
    },
    changeApartment: 'החלף דירה',
}
